<template>
  <div class="org-search-nr-select">
    <NrSelect
      v-model="orgSelection"
      :options="orgOptions"
      @open="searchOrgs"
      @search="searchOrgs"
      @input="setOrgId"
      :filterable="false"
      placeholder="Search for organization by name"
    >
      <template v-slot:label>Search for organization by name</template>
    </NrSelect>
  </div>
</template>

<script lang="ts" setup>
import { defineProps, ref, onMounted } from 'vue'
import NrSelect from '@nextrequestco/components/src/components/NrSelect'
import API from '../../../vue_shared/api.js'
import { debounce } from 'lodash'

const props = defineProps({
  accountId: {
    type: String,
    required: true
  }
})

const orgSelection = ref(null)
const orgOptions = ref([])
const cpAccessToken = ref('')

onMounted(() => {
  API.account().then((response) => {
    const token = response.data.cp_access_token
    if (token) {
      cpAccessToken.value = token
    }
  })
})

// Debounce the searchOrgs function to limit API calls while typing
const searchOrgs = debounce((keyword = '') => {
  API.searchOrgs(cpAccessToken.value, { searchTerm: keyword }).then(
    (response) => {
      const orgs = response.data.items
      orgOptions.value = orgs.map((org) => ({
        label: org.name,
        value: org.id
      }))
    }
  )
}, 300)

const setOrgId = (selectedOption) => {
  const modal = document.getElementById(`cp-organization-id-${props.accountId}`)
  const orgIdInputField = modal?.querySelector(
    `#cp-account-organization-id-${props.accountId}`
  ) as HTMLInputElement

  if (selectedOption && selectedOption.value) {
    orgIdInputField.value = selectedOption.value
  } else {
    orgIdInputField.value = ''
  }
}
</script>
<style lang="scss">
@import '@nextrequestco/components/src/styles/tokens/tokens.scss';

.org-search-nr-select {
  margin-bottom: $spacing-16;
}

.nr-select {
  // Override foundation styles for v-select component
  .v-select {
    border-radius: $spacing-4;
    background-color: $color-white;
    border-radius: $spacing-4;
    color: $color-black;
    max-width: 100%;
    width: 100%;
    align-items: center;
    border: $border-width-default solid $color-gray-60;
    box-shadow: none;
    display: inline-flex;
    font-size: $spacing-16;
    height: $spacing-40;
    justify-content: flex-start;
    padding-right: $spacing-4;

    .vs__search {
      font-size: $font-size-3;
      padding-left: $spacing-6;
      background: none;
      box-shadow: none;
      width: 0;
      max-width: 100%;
    }

    .vs__clear {
      margin: 0 $spacing-4 $spacing-4 0;
      &:hover {
        background: none;
      }
      &:focus-visible {
        background: none;
      }
    }

    .vs__dropdown-option {
      margin-bottom: 0;
      font-size: $font-size-3;
    }
  }
}
</style>
